import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService, EntityManager, EntityQuery, NamingConvention } from 'breeze-client';
import { AjaxHttpClientAdapter } from 'breeze-client/adapter-ajax-httpclient';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';
import { environment } from '../../../environments/environment';
import { Entities } from './entities';
import { UtilityService } from './utility.service';
import { GenesisTrailersRegistrationHelper } from '../model/registration-helper';
import { GenesisTrailersMetadata } from '../model/metadata';

// The EntityManagerProvider manages a static master manager and a per instance sandbox manager.
@Injectable()
export class EntityManagerProvider {
    private static _preparePromise: Promise<any>;
    private static _masterManager: EntityManager;
    static serviceName: string;

    constructor(
        http: HttpClient,
        private utilityService: UtilityService,
    ) {
        ModelLibraryBackingStoreAdapter.register();
        UriBuilderJsonAdapter.register();
        // UriBuilderODataAdapter.register();
        AjaxHttpClientAdapter.register(http);
        DataServiceWebApiAdapter.register();
        NamingConvention.camelCase.setAsDefault();

        EntityManagerProvider.serviceName = environment.serviceName + '/api/breeze';
        const dataService = new DataService({
            serviceName: EntityManagerProvider.serviceName,
            hasServerMetadata: false,
        });

        const masterManager = (EntityManagerProvider._masterManager = new EntityManager({
            dataService: dataService,
        }));
        const metadataStore = masterManager.metadataStore;

        metadataStore.importMetadata(GenesisTrailersMetadata.value);

        GenesisTrailersRegistrationHelper.register(masterManager.metadataStore);
    }

    async prepare(): Promise<any> {
        if (!EntityManagerProvider._preparePromise) {
            try {
                const query = EntityQuery.from('lookups');

                EntityManagerProvider._preparePromise = EntityManagerProvider._masterManager
                    .executeQuery(query)
                    .then((data) => {
                        Entities.lookups = data.results[0];
                        return Entities.lookups;
                    })
                    .catch((e) => {
                        EntityManagerProvider._preparePromise = null;
                        throw e;
                    });
                return EntityManagerProvider._preparePromise;
            } catch (e: any) {
                EntityManagerProvider._preparePromise = null;
                throw e;
            }
        }

        return EntityManagerProvider._preparePromise;
    }

    reset(manager: EntityManager): void {
        if (manager) {
            manager.clear();
            this.seedManager(manager);
        }
    }

    newManager(): EntityManager {
        const manager = EntityManagerProvider._masterManager.createEmptyCopy();
        this.seedManager(manager);
        return manager;
    }

    private seedManager(manager: EntityManager) {
        manager.importEntities(EntityManagerProvider._masterManager.exportEntities(null, { asString: false, includeMetadata: false }));
    }

    // private registerAnnotations(metadataStore: MetadataStore) {
    //     metadataStore.getEntityTypes().forEach((t: EntityType) => {
    //         let et = <EntityType>t;
    //         let ctor = <any>et.getCtor();
    //         if (ctor && ctor.getEntityTypeAnnotation) {
    //             let etAnnotation = <EntityTypeAnnotation>ctor.getEntityTypeAnnotation();
    //             et.validators.push(...etAnnotation.validators);
    //             etAnnotation.propertyAnnotations.forEach((pa) => {
    //                 let prop = et.getProperty(pa.propertyName);
    //                 prop.validators.push(...pa.validators);
    //                 prop.displayName = pa.displayName;
    //             });
    //             this.ignoreForSerialization(metadataStore, t, ...etAnnotation.ignoreForSerialization);
    //         }
    //     });
    // }

    // private ignoreForSerialization(metadataStore: MetadataStore, typeInfo: string | EntityType, ...propertyNames: string[]) {
    //     if (!propertyNames || propertyNames.length == 0) return;

    //     let entityType = typeof (typeInfo) === 'string' ? <EntityType>metadataStore.getEntityType(<string>typeInfo) : <EntityType>typeInfo;

    //     // Recursivley walk the inheritance tree and ignore the same properties for all parent types
    //     let parentTypes = metadataStore.getEntityTypes().filter(type => {
    //         let parentType = <EntityType>type;
    //         return parentType.baseEntityType && parentType.baseEntityType === entityType;
    //     });
    //     parentTypes.forEach((parentType: EntityType) => this.ignoreForSerialization(metadataStore, parentType, ...propertyNames));

    //     // Now ignore for current type
    //     let dps = propertyNames.map(propertyName => {
    //         let dp = entityType.getDataProperty(propertyName);
    //         if (!dp) {
    //             console.warn(`No data property with name ${propertyName} found in entity type ${entityType.shortName}`);
    //         }
    //         return dp;
    //     });
    //     // Get all the nulls out
    //     _.remove(dps, dp => !dp);

    //     // Get existing ignored properties
    //     let ignoredProperties: DataProperty[] = (<any>entityType).$ignoredProperties;

    //     // Signals that we've already installed our custom serializerFn
    //     if (ignoredProperties) {
    //         _.remove(dps, dp => _.includes(ignoredProperties, dp))
    //         ignoredProperties = ignoredProperties.concat(dps);
    //     } else {
    //         // First ignored properties for this entity type
    //         ignoredProperties = dps;
    //         let origSerializerFn: (dataProperty: DataProperty, value: any) => any = (<any>entityType).serializerFn;
    //         entityType.setProperties({
    //             serializerFn: (dp, value) => {
    //                 if (_.includes((<any>entityType).$ignoredProperties, dp)) {
    //                     // Return undefined if property is ignored for serialization
    //                     return undefined;
    //                 }

    //                 return origSerializerFn ? origSerializerFn(dp, value) : value;
    //             }
    //         });
    //     }
    //     (<any>entityType).$ignoredProperties = ignoredProperties;
    // }
}
